import React from "react";
//import {} from "react-bootstrap";
import RespIm from "./RespIm";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Mailsent(props) {
  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <a href="https://www.entrenamientopostural.com/">
          <RespIm
            x0={1003}
            y0={700}
            x={600}
            src={require("../images/Logo.png").default}
          />
        </a>
      </div>
      <div style={{ textAlign: "center" }}>
        <h5>
          Se te envió un correo a tu cuenta de email para verificar el mismo.
          Por favor seguí los pasos para activar tu cuenta. Gracias{" "}
        </h5>
      </div>
    </div>
  );
}
